import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaCar, FaMotorcycle, FaTruck, FaBus, FaShippingFast,
  FaFire, FaBox, FaCog, FaPlane,
  FaHeartbeat
} from 'react-icons/fa';
import '../AdminDashboard.css';
import './QuotationBuilderHome.css';

const QuotationBuilderHome = () => {

  const motorInsurance = [
    { id: 'car', title: 'Private Car Insurance', icon: <FaCar />, route: '/admin/quotation-builder/motor/car' },
    { id: 'bike', title: 'Two Wheeler Insurance', icon: <FaMotorcycle />, route: '/admin/quotation-builder/motor/bike' },
    { id: 'cv', title: 'Commercial Vehicle Insurance', icon: <FaTruck />, route: '/admin/quotation-builder/motor/cv' },
    { id: 'pcv', title: 'Passenger Carrying Vehicle', icon: <FaBus />, route: '/admin/quotation-builder/motor/pcv' },
    { id: 'gcv', title: 'Goods Carrying Vehicle', icon: <FaShippingFast />, route: '/admin/quotation-builder/motor/gcv' }
  ];

  const nonMotorInsurance = [
    { id: 'fire', title: 'Fire Insurance', icon: <FaFire />, route: '/admin/quotation-builder/non-motor/fire' },
    { id: 'package', title: 'Package Insurance', icon: <FaBox />, route: '/admin/quotation-builder/non-motor/package' },
    { id: 'engineering', title: 'Engineering Insurance', icon: <FaCog />, route: '/admin/quotation-builder/non-motor/engineering' },
    { id: 'travel', title: 'Travel Insurance', icon: <FaPlane />, route: '/admin/quotation-builder/non-motor/travel' }
  ];

  const retailHealth = [
    { id: 'health', title: 'Health Insurance', icon: <FaHeartbeat />, route: '/admin/quotation-builder/health/retail/health' }
  ];

  const groupHealth = [
    { id: 'general-group', title: 'General Group Health Insurance', icon: <FaHeartbeat />, route: '/admin/quotation-builder/health/group/general-group' }
  ];

  const InsuranceCard = ({ item }) => {
    return (
      <Link to={item.route} className="insurance-card-link">
        <div className="insurance-card card">
          <div className="card-icon">{item.icon}</div>
          <h3 className="card-title">{item.title}</h3>
          <div className="card-menu">
            <span className="menu-dots">⋯</span>
          </div>
        </div>
      </Link>
    );
  };

  return (
    <div className="quotation-builder-home">
      <div className="admin-header">
        <div className="container">
          <div className="admin-header-content quotation-builder-home-header">
            <div className="qb-header-left">
            </div>
            <div className="qb-header-center">
              <h1 style={{ color: "#0A2342", textShadow: "none" }}>Quotation Builder</h1>
              <p style={{ color: "#0A2342", textShadow: "none" }}>
                Select an insurance type to create a quotation
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="admin-content">
        <div className="container">
          {/* Motor Insurance Section */}
          <section className="qb-section">
            <h2 className="section-header">MOTOR INSURANCE</h2>
            <div className="insurance-grid">
              {motorInsurance.map((item) => (
                <InsuranceCard key={item.id} item={item} />
              ))}
            </div>
          </section>

          {/* Non-Motor Insurance Section */}
          <section className="qb-section">
            <h2 className="section-header">NON-MOTOR INSURANCE</h2>
            <div className="insurance-grid">
              {nonMotorInsurance.map((item) => (
                <InsuranceCard key={item.id} item={item} />
              ))}
            </div>
          </section>

          {/* Health Insurance Section */}
          <section className="qb-section">
            <h2 className="section-header">HEALTH INSURANCE</h2>
            
            <div className="health-subsection">
              <h3 className="subsection-header">Retail Health Insurance</h3>
              <div className="insurance-grid">
                {retailHealth.map((item) => (
                  <InsuranceCard key={item.id} item={item} />
                ))}
              </div>
            </div>

            <div className="health-subsection">
              <h3 className="subsection-header">Group Health Insurance</h3>
              <div className="insurance-grid">
                {groupHealth.map((item) => (
                  <InsuranceCard key={item.id} item={item} />
                ))}
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default QuotationBuilderHome;

